import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { currentOpenTripList } from "../../../Api/api";

// Define an initial state for the slice
const initialState = {
   data: null,
   loading: false,
   error: null,
};



export const currentOpenTripListAsync=createAsyncThunk(
   "dashboard/current-open-trip",
   async ({ done, err }, thunkAPi) => {
      try {
         
         const { data: response } = await currentOpenTripList();
         if (response.statusCode === 200) {
            done && done(response.res);
            return thunkAPi.fulfillWithValue(response.res);
         } else {
            throw response;
         }
      } catch (error) {
         // You can customize the error handling here
         
         err && err(error.message);
         return thunkAPi.rejectWithValue(error);
      }
   }

);

const currentOpenTripListSlice = createSlice({
   name: "dashboard/current-open-trip",
   initialState,
   reducers: {

   },
   extraReducers: (builder) => {
      builder
         .addCase(currentOpenTripListAsync.pending, (state) => {
            state.loading = true;
            state.error = null;
         })
         .addCase(currentOpenTripListAsync.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            //console.log("currentOpenTripListAsync",action.payload)
         })
         .addCase(currentOpenTripListAsync.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload; // error message from the rejectWithValue call
         });
   },
});



export default currentOpenTripListSlice.reducer;